<template>
    <span v-html="iconHtml"></span>
</template>

<script>
    import iconApi from "../../Util/icons";

    export default {
        name: "file-icon",
        computed: {
            iconHtml(){
                return iconApi.getFileIcon(this.name, { size: this.size });
            }
        },
        props: {
            name: {
                required: true,
                type: String
            },
            size: { }
        }
    }
</script>

<style scoped>

</style>
